import { Component, Input, OnInit, HostListener, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { AveriasService } from '../servicios/averias.service';
import { SelectItem } from 'primeng/api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { CriterioSimilitudDTO, CriterioSimilitudModificarDTO } from '../entidades/entidades.component';
import { NbSortDirection, NbGetters, NbSortRequest, NbTreeGridDataSource, NbTreeGridDataSourceBuilder, } from '@nebular/theme';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { NbCheckboxModule } from '@nebular/theme';
import {NbFormFieldModule} from '@nebular/theme';
import { NbInputModule } from '@nebular/theme';

interface TreeNode<T> {
  data: T;
  children?: FSEntry[];
  expanded?: boolean;
}

interface FSEntry {
  Descripcion: string;
  DescripcionAbreviada: string;
  Orden: any;
}


@Component({
    selector: 'app-criterios-de-similitud',
    templateUrl: './criterios-de-similitud.component.html',
    styleUrls: ['./criterios-de-similitud.component.css'],
    standalone: true,
    imports: [SpinnerComponent,FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule,MatFormFieldModule,MatInputModule,AngularSlickgridModule,NbTabsetModule, 
      MatDatepickerModule, NbCheckboxModule, MatNativeDateModule, NbSelectModule,
       NbTreeGridModule, MultiSelectModule,
        NbFormFieldModule, // ¡Este es el que falta!
      NbInputModule,     // ¡Y este para nbInput!

    ],
})
export class CriteriosDeSimilitudComponent implements OnInit {
  durationInSeconds = 4;
  severidadCompleto;
  severidad: SelectItem[];
  showSeveridad = false;
  idSeveridad: number[];
  severidadOk = false
  severidadProcesado = [];
  // similitudCompleto;
  similitud: SelectItem[];
  showSimilitud = false;
  idSimilitud: number[];
  similitudOK = false
  similitudProcesado = [];
  tipoCompleto;
  tipo: SelectItem[];
  showTipo = false;
  idTipo: number[];
  tipoOk = false;
  tipoProcesado = [];
  zonaCuadranteCompleto;
  zonaCuadrante: SelectItem[];
  showZonaCuadrante = false;
  idZonaCuadrante: number[];
  zonaCuadranteOk = false;
  zonaCuadranteProcesado = [];
  descripcionAlta;
  descripcionBreveAlta;
  OrdenAlta;
  OrdenModificar;
  habilitarGuardar = false;
  idCliente: number;
  tipoProcesadoModificar = [];
  severidadProcesadoModificar = [];
  zonaCuadranteProcesadoModificar = [];
  descripcionEditarSimilitud
  descripcionBreveEditarSimilitud;
  numeroOrdenEditarSimilitud;
  showGrilla = false;
  showSpinnerModificar = false;
  showSpinnerGuardar = false;
  showSpinner = false;
  similitudSeleccionada;

  datosCriterioSimilitud =[];

  customColumn = 'Descripcion';
  defaultColumns = ['DescripcionAbreviada', 'Orden'];
  allColumns = [this.customColumn, ...this.defaultColumns];
  source: NbTreeGridDataSource<FSEntry>;

  iconTreeGridAbierta:boolean=false;
  iconNameTreeGrid:string="arrow-ios-forward-outline";

  searchTerm: string = '';
  filteredSeveridad: any[] = [];
  //dropdownOpen = false;

 @ViewChild('dropdownSeveridad') dropdownSeveridadRef!: ElementRef;
  @ViewChild('dropdownZonaCuadrante') dropdownZonaCuadranteRef!: ElementRef;
  @ViewChild('dropdownTipoAveria') dropdownTipoAveriaRef!: ElementRef;

  dropdownOpen: boolean = false;
  dropdownOpenZc: boolean = false; // Estado para Zona Cuadrante
  dropdownOpenTipoAveria: boolean = false; // Estado para Tipo Avería

  // Lógica para el contenedor principal.
  // Evita que el click se propague al 'document' si ocurre dentro del contenedor.
  // handleContainerClick(event: MouseEvent): void {
  //   event.stopPropagation();
    
  //   if(this.dropdownOpen)
  //     this.dropdownOpen = false;
  //   if(this.dropdownOpenZc)
  //     this.dropdownOpenZc = false;
  //   if(this.dropdownOpenTipoAveria)
  //     this.dropdownOpenTipoAveria = false;
  // }

  constructor(private AveriasService: AveriasService, private _snackBar: MatSnackBar,
    private dataSourceBuilder: NbTreeGridDataSourceBuilder<FSEntry>, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService,
    private eRef: ElementRef) {
  }

//TIPO DE AVERIA
 // tipoProcesado: string[] = [];
  //dropdownOpenTipoAveria = false;
  searchTermTipoAveria = '';
  filteredTipoAveria: any[] = [];

  toggleDropdownTipoAveria() {
    this.dropdownOpenTipoAveria = !this.dropdownOpenTipoAveria;
  }

  toggleTipoAveriaOption(value: string) {
    const index = this.tipoProcesado.indexOf(value);
    if (index > -1) {
      this.tipoProcesado.splice(index, 1);
    } else {
      this.tipoProcesado.push(value);
    }
  }

  filterTipoAveriaOptions() {
    const term = this.searchTermTipoAveria.toLowerCase();
    this.filteredTipoAveria = this.tipo.filter(opt =>
      opt.label.toLowerCase().includes(term)
    );
  }

  getTipoAveriaLabel(): string {
    if (!this.tipoProcesado.length) return 'Tipo Avería';
    const labels = this.tipo
      .filter(opt => this.tipoProcesado.includes(opt.value))
      .map(opt => opt.label);
    return labels.join(', ');
  }

//END TIPO AVERIA



//ZONA CUADRANTE
//zonaCuadranteProcesado: string[] = [];
searchTermZc: string = '';
//dropdownOpenZc: boolean = false;
filteredZonaCuadrante : any[] = [];

toggleDropdownZonaCuadrante() {
  this.dropdownOpenZc = !this.dropdownOpenZc;
}

toggleZonaCuadranteOption(value: string) {
  const index = this.zonaCuadranteProcesado.indexOf(value);
  if (index > -1) {
    this.zonaCuadranteProcesado.splice(index, 1);
  } else {
    this.zonaCuadranteProcesado.push(value);
  }
}

getZonaCuadranteLabel(): string {
  const selected = this.zonaCuadrante.filter(option =>
    this.zonaCuadranteProcesado.includes(option.value)
  ).map(opt => opt.label);
  return selected.length ? selected.join(', ') : 'Zona Cuadrante';
}

filterZonaCuadranteOptions() {
  this.filteredZonaCuadrante = this.zonaCuadrante.filter(option =>
    option.label.toLowerCase().includes(this.searchTermZc.toLowerCase())
  );
}
//END ZONA CUADRANTE





  //SERVERIDAD
   toggleDropdown(event: MouseEvent): void {
      
     event.stopPropagation(); // ¡Detiene la propagación aquí!
    this.dropdownOpen = !this.dropdownOpen;
    if (this.dropdownOpen) {
      this.dropdownOpenZc = false;
      this.dropdownOpenTipoAveria = false;
    }

  }

  

    @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }

  isSelected(option: any) {
    return this.severidadProcesado.some(o => o.value === option.value);
  }

  toggleOption(option: any) {
    if (this.isSelected(option)) {
      this.severidadProcesado = this.severidadProcesado.filter(o => o.value !== option.value);
    } else {
      this.severidadProcesado = [...this.severidadProcesado, option];
    }
  }

  filterSeveridadOptions() {
  const term = this.searchTerm.toLowerCase();
  this.filteredSeveridad = this.severidad.filter(opt =>
    opt.label.toLowerCase().includes(term)
  );
}

getSeveridadProcesadoLabel(): string {
  return this.severidadProcesado && this.severidadProcesado.length
    ? this.severidadProcesado.map((s: any) => s.label).join(', ')
    : 'Severidad';


    // if (this.severidadProcesado.length === 0) {
    //   return 'Seleccionar';
    // } else if (this.severidadProcesado.length === 1) {
    //   return this.severidadProcesado[0].label;
    // } else {
    //   return `${this.severidadProcesado.length} seleccionados`;
    // }


}

//END SERVERIDAD


 // Este HostListener se encarga de cerrar los dropdowns solo cuando el clic
  // ocurre *fuera* de sus respectivos elementos.

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Solo cierra si el dropdown está abierto Y el clic NO fue dentro de él
    if (this.dropdownOpen &&
        this.dropdownSeveridadRef &&
        !this.dropdownSeveridadRef.nativeElement.contains(target)) {
      this.dropdownOpen = false;
    }

    if (this.dropdownOpenZc &&
        this.dropdownZonaCuadranteRef &&
        !this.dropdownZonaCuadranteRef.nativeElement.contains(target)) {
      this.dropdownOpenZc = false;
    }

    if (this.dropdownOpenTipoAveria &&
        this.dropdownTipoAveriaRef &&
        !this.dropdownTipoAveriaRef.nativeElement.contains(target)) {
      this.dropdownOpenTipoAveria = false;
    }
  }


  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.consultarSeveridad();
    this.consultarTipoAveria();
    this.consultarZonaCuadrante();
    this.traerDatos();
    // this.consultarSimilitud();
    this.svcAnalytics.setAnalyticsPageView();
   this.filteredSeveridad = [...this.severidad];
   this.filteredZonaCuadrante = [...this.zonaCuadrante];
    this.filteredTipoAveria = [...this.tipo];

  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  capturarSimilitud(event) {
    this.idSimilitud = event;
    this.similitudOK = true;
  }
  consultarSeveridad() {
    this.AveriasService.getSeveridad(this.idCliente).subscribe(
      data => {
        this.severidadCompleto = data;
        this.severidad = this.insertarSeveridad(data);
        this.showSeveridad = true;
        this.filteredSeveridad = [...this.severidad];
      });
  }
  insertarSeveridad(armarSeveridad) {
    let averiasSeveridad: Array<any> = [];
    armarSeveridad.content.forEach(element => {
      averiasSeveridad.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasSeveridad;
  };
  capturarSeveridad(event) {
    this.idSeveridad = event;
    this.severidadOk = true;
  }
  consultarTipoAveria() {
    this.AveriasService.getTipo(this.idCliente).subscribe(
      data => {
        this.tipoCompleto = data;
        this.tipo = this.insertarTipoAveria(data);
        this.showTipo = true;
        this.filteredTipoAveria = [...this.tipo];
      });
  }
  insertarTipoAveria(armarTipo) {
    let averiasTipo: Array<any> = [];
    armarTipo.content.forEach(element => {
      averiasTipo.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasTipo;
  };
  capturarTipo(event) {
    this.idTipo = event;
    this.tipoOk = true;
  }
  consultarZonaCuadrante() {
    this.AveriasService.getZonaCuadranteDetalle(this.idCliente).subscribe(
      data => {
        this.zonaCuadranteCompleto = data;
        this.zonaCuadrante = this.insertarZonaCuadrante(data);
        this.showZonaCuadrante = true;
          this.filteredZonaCuadrante = [...this.zonaCuadrante];
      });
  }
  insertarZonaCuadrante(armarZonaCuadrante) {
    let ZonaCuadrante: Array<any> = [];
    armarZonaCuadrante.content.forEach(element => {
      ZonaCuadrante.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return ZonaCuadrante;
  };
  capturarZonaCuadrante(event) {
    this.idZonaCuadrante = event;
    this.zonaCuadranteOk = true;
  }
  guardarCriterio() {
    let similitud: CriterioSimilitudDTO;

    if (this.descripcionAlta == undefined || this.descripcionAlta == "") {
      this.openSnackBar("Debe ingresar Descripción ❌");
      return;
    }
    if (this.descripcionBreveAlta == undefined || this.descripcionBreveAlta == "") {
      this.openSnackBar("Debe ingresar Descripción Breve ❌");
      return;
    }
    if (this.OrdenAlta == undefined || this.OrdenAlta == "") {
      this.openSnackBar("Debe ingresar un Orden ❌");
      return;
    }

    if (this.severidadProcesado != undefined || this.tipoProcesado != undefined || this.zonaCuadranteProcesado != undefined) {
      if (this.severidadProcesado.length > 0 || this.tipoProcesado.length > 0 || this.zonaCuadranteProcesado.length > 0) {
      } else {
        this.openSnackBar("Debe seleccionar una Severidad, Zona Cuadrante o Tipo Avería ❌");
        return;
      }
    } else {
      this.openSnackBar("Debe seleccionar una Severidad, Zona Cuadrante o Tipo Avería ❌");
      return;
    }
    similitud = {
      idCliente: this.idCliente,
      descripcion: this.descripcionAlta,
      descripcionAbreviada: this.descripcionBreveAlta,
      orden: this.OrdenAlta,
      criterioSeveridad: this.severidadProcesado == undefined?[]:this.severidadProcesado,
      criterioZonaCuadrante : this.zonaCuadranteProcesado == undefined?[]:this.zonaCuadranteProcesado,
      criterioTipoAveria: this.tipoProcesado == undefined?[]:this.tipoProcesado
    }
    this.showSpinnerGuardar = true;
    this.AveriasService.altaSimilitud(similitud).subscribe(data => {
      if (data["status"] == 200) {
        this.openSnackBar('Los cambios se han guardado correctamente');
        //gtag alta
        this.svcAnalytics.setAnalyticsAltaButton();
      } else {
        this.openSnackBar('Ha ocurrido un error al guardarse los datos');
      }
      this.showSpinnerGuardar = false;
      this.traerDatos();
    })
      this.descripcionEditarSimilitud = '';
      this.descripcionAlta = '';
      this.descripcionBreveAlta = '';
      this.OrdenAlta = '',
      this.severidadProcesado = [];
      this.zonaCuadranteProcesado = []
      this.tipoProcesado = [];

  }
  modificarCriterio() {
    let similitud: CriterioSimilitudModificarDTO;

    if (this.descripcionEditarSimilitud == null || this.descripcionEditarSimilitud == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreveEditarSimilitud == null || this.descripcionBreveEditarSimilitud == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.numeroOrdenEditarSimilitud == null || this.numeroOrdenEditarSimilitud == "") {
      this.openSnackBar("Debe Completar el Orden ❌");
    } else {
      this.showSpinnerModificar = true;
      similitud = {
        idCriterioSimilitud: this.similitudSeleccionada,
        descripcion: this.descripcionEditarSimilitud,
        descripcionAbreviada: this.descripcionBreveEditarSimilitud,
        criterioSeveridad: this.severidadProcesadoModificar == undefined?[]:this.severidadProcesadoModificar,
        criterioZonaCuadrante : this.zonaCuadranteProcesadoModificar == undefined?[]:this.zonaCuadranteProcesadoModificar,
        criterioTipoAveria: this.tipoProcesadoModificar == undefined?[]:this.tipoProcesadoModificar,
        orden: this.numeroOrdenEditarSimilitud
      }
      this.AveriasService.postSimilitudModificar(similitud).subscribe(data => {
        if (data["status"] == 200) {
          this.openSnackBar('Los cambios se han guardado correctamente');
          // this.consultarSimilitud();
          //gtag modificacion
          this.svcAnalytics.setAnalyticsModificacionButton();
        } else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos');
        }
        this.showSpinnerModificar = false;
      })
      this.descripcionEditarSimilitud = '';
      this.descripcionBreveEditarSimilitud = '';
      this.numeroOrdenEditarSimilitud = '';
      this.tipoProcesadoModificar = [],
      this.severidadProcesadoModificar = [];
      this.zonaCuadranteProcesadoModificar = []
      this.similitudSeleccionada = '';
    }
  }
  obtenerDescripcionDropdown(idSimilitud: number) {
    // let resp = this.similitudCompleto.content.find(n => n['id'] == idSimilitud);
    let respDropdown = this.similitud.find(n => n["value"] == idSimilitud);
    this.descripcionBreveEditarSimilitud = respDropdown['descripcionAbreviada'];
    this.descripcionEditarSimilitud = respDropdown['descripcion'];
    this.numeroOrdenEditarSimilitud = respDropdown['orden'];

    this.zonaCuadranteProcesadoModificar = []
    respDropdown['listaCriterioZonaCuadrante'].forEach(element => {
      this.zonaCuadranteProcesadoModificar.push(
        element['id']
      )
    })
    this.severidadProcesadoModificar = []
    respDropdown['listaCriterioSeveridad'].forEach(element => {
      this.severidadProcesadoModificar.push(
        element['id']
      )
    });
    this.tipoProcesadoModificar = []
    respDropdown['listaCriterioTipoAveria'].forEach(element => {
      this.tipoProcesadoModificar.push(
        element['id']
      )
    })
    
  }
  traerDatos(){
    this.showSpinner = true;
    this.showGrilla = false;
    let cliente = {idCliente : this.idCliente}
    this.AveriasService.ListaSimilitud(cliente).subscribe(datosSimilitud => {
      if (datosSimilitud.status == "200") {
      this.similitud = this.insertarSimilitud(datosSimilitud.body);
      this.datosCriterioSimilitud = [];
      datosSimilitud.body.forEach(element => {
        this.datosCriterioSimilitud.push({
          value: element.idCriterioSimilitud,
          descripcion: element.criterioSimilitud,
          descripcionAbreviada: element.criterioSimilitud,
          listaCriterioTipoAveria: element.listaCriterioTipoAveria,
          listaCriterioSeveridad: element.listaCriterioSeveridad,
          listaCriterioZonaCuadrante: element.listaCriterioZonaCuadrante,
          orden: element.orden
        });
      })
      this.source = this.dataSourceBuilder.create(this.llenarTreeGrid());
      this.showSpinner = false;
      this.showGrilla = true;
    }
    }, error=>{
      this.showSpinner = false;
      this.showGrilla = true;
    })
  }

  insertarSimilitud(armarSimilitud) {
    let similitud: Array<any> = [];
    armarSimilitud.forEach(element => {
      similitud.push({
        label: element.criterioSimilitud,
        value: element.idCriterioSimilitud,
        descripcion: element.criterioSimilitud,
        descripcionAbreviada: element.criterioSimilitud,
        listaCriterioTipoAveria: element.listaCriterioTipoAveria,
        listaCriterioSeveridad: element.listaCriterioSeveridad,
        listaCriterioZonaCuadrante: element.listaCriterioZonaCuadrante,
        orden: element.orden
      });
    })
    return similitud;
  };
  stateTreeGrid(){
    if(this.iconTreeGridAbierta){
      this.iconTreeGridAbierta =false;
      this.iconNameTreeGrid="arrow-ios-forward-outline";
    }
    else{
      this.iconTreeGridAbierta=true;
      this.iconNameTreeGrid="arrow-ios-downward-outline";
    }
  }
  llenarTreeGrid() {
    let datos: TreeNode<FSEntry>[] = []
    // let listaSeveridad: [{ data: {Descripcion:string, DescripcionAbreviada:string, Orden:string},
    //                     children: [{data: {Descripcion:string, DescripcionAbreviada:string, Orden:string}}] }]
    // let listaTipo:[{ data: {Descripcion:string, DescripcionAbreviada:string, Orden:string},
    //   children: [{data: {Descripcion:string, DescripcionAbreviada:string, Orden:string}}] }];
    // let listaZonaDetalle:[{ data: {Descripcion:string, DescripcionAbreviada:string, Orden:string},
    //       children: [{data: {Descripcion:string, DescripcionAbreviada:string, Orden:string}}] }];

    // var severidades: [{data: {Descripcion:string, DescripcionAbreviada:string, Orden:string}}]=
    // [{data: {Descripcion:'', DescripcionAbreviada:'', Orden:''}}];
    // var tipos: [{data: {Descripcion:string, DescripcionAbreviada:string, Orden:string}}]=
    // [{data: {Descripcion:'', DescripcionAbreviada:'', Orden:''}}];
    // var zonasDetalles: [{data: {Descripcion:string, DescripcionAbreviada:string, Orden:string}}]=
    // [{data: {Descripcion:'', DescripcionAbreviada:'', Orden:''}}];
    let listaSeveridad=[];
    let listaTipo=[];
    let listaZonaDetalle=[];

    let severidades=[];
    let tipos=[]
    let zonasDetalles=[];

    let severidadTipoZona=[];
    this.datosCriterioSimilitud.forEach( element => {
      listaSeveridad=[];
      listaTipo=[];
      listaZonaDetalle=[];

      severidades=[];
      tipos=[]
      zonasDetalles=[];
      severidadTipoZona=[];

      //cargamos severidad
      element.listaCriterioSeveridad.forEach(element => {
        severidades.push({data: { Descripcion: element['descripcion'], DescripcionAbreviada:  element['descripcionAbreviada'], Orden: "" }}
        );
      })
      severidadTipoZona.push({ data: {Descripcion: 'Severidad', DescripcionAbreviada: '', Orden:'Cantidad: ' + severidades.length },  children:  severidades });
      //cargamos tipo
      element.listaCriterioTipoAveria.forEach(element => {
        tipos.push({data: { Descripcion: element['descripcion'], DescripcionAbreviada:  element['descripcionAbreviada'], Orden: "" }}
        );
      })
      severidadTipoZona.push({ data: {Descripcion: 'Tipos', DescripcionAbreviada: '', Orden:'Cantidad: ' + tipos.length }, children:  tipos });
      //cargamos zona detalle
      element.listaCriterioZonaCuadrante.forEach(element => {
        zonasDetalles.push({data: { Descripcion: element['descripcion'], DescripcionAbreviada:  element['descripcionAbreviada'], Orden: "" }}
        );
      })
      severidadTipoZona.push({data: {Descripcion: 'Zonas Detalles', DescripcionAbreviada: '', Orden:'Cantidad: ' + zonasDetalles.length }, children:  zonasDetalles });
      
      datos.push(
        { data:
          {Descripcion: element.descripcion, DescripcionAbreviada: element.descripcionAbreviada, Orden: element.orden},
          children: severidadTipoZona
        }
      )
    })
    return datos;
  }
  getShowOn(index: number) {
    const minWithForMultipleColumns = 400;
    const nextColumnStep = 100;
    return minWithForMultipleColumns + (nextColumnStep * index);
  }
}